import type { ChangelogEntry } from "../types";

/** Ansatte kan bytte kundelogo på kundekortet (VIB-2935). */
export const ENDRE_KUNDELOGO_2026_10: ChangelogEntry = {
  id: "2026-10-25-endre-kundelogo",
  date: "2026-10-25",
  title: "Bytt logo på kundekortet",
  summary:
    "Klikk på logoen øverst på kundekortet for å hente den fra en nettside, laste opp et bilde eller fjerne den. Endringen blir stående, også etter nattens synk.",
  sections: [
    {
      heading: "Kunder",
      minRole: "user",
      items: [
        {
          title: "Endre logo",
          kind: "nytt",
          featureFlag: "feature_crm_kundekort",
          body: "Hent fra nettside: skriv inn adressen, så finner vi logoen bedriften viser selv. Last opp bilde: PNG, JPG, SVG eller WebP, maks 512 kB, i en versjon for lys bakgrunn. Fjern logo gir initialer igjen. Alle endringer vises i hendelsesloggen med hvem som gjorde dem.",
        },
      ],
    },
  ],
};
